import React, { Fragment, useCallback, useContext, useMemo } from 'react';

import ShowInAnimation from 'app/home/general-components/ShowInAnimation';

import { LocalizationContext, useLocalizedStrings } from 'app/localization/Context';
import { HistoryStackContext } from 'app/home/general-components/HistoryStackContext';

import { supportedRemoteDeviceTypes } from 'app/home/main-pages/devices/Devices';
import { DeviceType } from 'app/model/Device';

import { ReactComponent as IconPlus } from 'images/general/icon-add.svg';
import { ReactComponent as IconRemote } from 'images/device/symbol/hinava_gradient/remote.svg';
import { ReactComponent as IconDisconnect } from 'images/general/disconnect.svg';

import { ReactComponent as IconRemoteAc } from 'images/device/symbol/blue/remote-ac.svg';
import { ReactComponent as IconRemoteFan } from 'images/device/symbol/blue/remote-fan.svg';
import { ReactComponent as IconRemoteHomeTheater } from 'images/device/symbol/blue/remote-home-theater.svg';
import { ReactComponent as IconRemoteProjector } from 'images/device/symbol/blue/remote-projector.svg';
import { ReactComponent as IconRemoteReciever } from 'images/device/symbol/blue/remote-reciever.svg';
import { ReactComponent as IconRemoteSoundbar } from 'images/device/symbol/blue/remote-soundbar.svg';
import { ReactComponent as IconRemoteTv } from 'images/device/symbol/blue/remote-tv.svg';

import './All.scss'

export function RemoteDetail({ device, gateway }) {
    const hs = useContext(HistoryStackContext);
    const s = useLocalizedStrings();

    // const [_selectedSubDeviceMac, setSelectedSubDeviceMac] = useState(undefined);

    const subDevices = useMemo(() => {
        let subDevices = [];
        if (device.sub_devices) {
            subDevices = device.sub_devices.filter(
                d => supportedRemoteDeviceTypes.includes(d.type));
        }
        return subDevices;
    }, [device.sub_devices]);

    const onAddRemoteClick = useCallback(() => {
        if (device.active) {
            hs.push("/devices/detail/remote/add", {parentDeviceMac: device.mac});
        }
    }, [hs, device.active, device.mac]);

    return (
        <Fragment>
            <div className={device.active ? "remote-icon-container" : "remote-icon-container dc-mode"}>
                <IconRemote className="image" />
                {device.active ? null :
                    <div className="device-detail-dc-panel">
                        <div>
                            <div />
                            <div className="label connection-label">{s.deviceDisonnected}</div>
                            <IconDisconnect className="icon" />
                            <div />
                        </div>
                    </div>}
            </div>

            <div className={device.active ? "remotes-list-header" : "remotes-list-header transparent"}>
                <div className="label">
                    {s.subRemotesOfThisRemote}
                </div>
                <div />
                {
                    gateway.currentUser.permissions.setting ? (
                        <div className="add-remote-border" onClick={onAddRemoteClick}>
                            <div className="label">
                                {s.addVirtualRemote.button}
                            </div>
                            <IconPlus className="icon" />
                        </div>
                    ) : null
                }
            </div>

            {
                (subDevices.length > 0) ? <div className="remotes">
                    {subDevices.map(subDevice => (
                        <RemoteSubDeviceCard
                            device={subDevice}
                            onClick={() => {
                                hs.push("/devices/detail/remote-control", {
                                    parentDeviceMac: device.mac,
                                    subDeviceMac: subDevice.mac,
                                });
                            }}
                            opacity={device.active ? 1 : 0.7}
                            key={"remote-sub-device-mac-for-detail-" + subDevice.mac} />
                    ))}
                </div> : <div className="no-remote-lable">
                    {s.noVirtualDeviceInRemote}
                </div>
            }

            {/* <SidePageAnimator
                isAnimationEnable={p.state.goDirectlyToSubDevicePage !== true}
                show={selectedSubDevice !== undefined}>
                <RemoteControl
                    active={device.active}
                    negotiatedProtocol={negotiatedProtocol} currentUser={gateway.currentUser}
                    device={selectedSubDevice} dismiss={() => {
                        if (p.state.goDirectlyToSubDevicePage === true)
                            dismiss();
                        else
                            setRemoteSelectedSubDeviceMac(undefined);
                    }} />
            </SidePageAnimator> */}

            {/* <SidePageAnimator
                isAnimationEnable={true}
                show={isAddRemoteActive}>
                <AddRemote
                    subDevices={subDevices}
                    deviceMac={device.mac}
                    gateway={gateway}
                    dismiss={() => { setAddRemoteActive(false) }} />
            </SidePageAnimator> */}
        </Fragment>
    );
}

function RemoteSubDeviceCard({ device, onClick, opacity }) {
    let iconSvg = undefined;
    switch (device.type) {
        case DeviceType.tvRemote:
            iconSvg = IconRemoteTv;
            break;
        case DeviceType.receiverRemote:
            iconSvg = IconRemoteReciever;
            break;
        case DeviceType.fanRemote:
            iconSvg = IconRemoteFan;
            break;
        case DeviceType.splitRemote:
            iconSvg = IconRemoteAc;
            break;
        case DeviceType.soundBarRemote:
            iconSvg = IconRemoteSoundbar;
            break;
        case DeviceType.projectorRemote:
            iconSvg = IconRemoteProjector;
            break;
        case DeviceType.homeTheatreRemote:
        default:
            iconSvg = IconRemoteHomeTheater;
            break;
    }

    return (
        <div className="card" onClick={onClick} style={{ opacity: opacity }}>
            {React.createElement(iconSvg, { className: "icon" })}
            <div className="name">
                {device.name}
            </div>
        </div>
    )
}

// used in Rooms
export function SidePageAnimator({ show, children, isAnimationEnable }) {
    const l = useContext(LocalizationContext);

    return (
        <ShowInAnimation
            show={show}
            transformVariants={l.isRTL ? animationPageVariantsRTL : animationPageVariantsLTR}
            duration={isAnimationEnable ? 0.5 : 0}
            // duration={isAnimationEnable ? 5 : 0}
            ease="ease-in-out"
            className="device-detail-rename-device-page">
            {children}
        </ShowInAnimation>
    )
}

const animationPageVariantsRTL = {
    in: "translateX(-100%)",
    out: "translateX(-200%)",
};
const animationPageVariantsLTR = {
    in: "translateX(-100%)",
    out: "translateX(0%)",
};
